
export default {
  props: {
    show: {
      // 是否展示该组件
      type: Boolean,
      default: false
    },
    isShowCountyCode: {
      // 是否展示code
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      firstLoad: true, // 是否为首次加载该组件
      seleLetter: 'A', // 选中的字母
      searchCountry: '', // 搜索绑定
      goodMenletter: this.$store.state.LanguageCode != 'zh-cn' && this.$store.state.LanguageCode != 'zh-tw' && this.$store.state.LanguageCode != 'zh' && this.$store.state.LanguageCode != 'zh-hk' ? ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'Y', 'Z'] : ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'R', 'S', 'T', 'W', 'X', 'Y', 'Z'],
      countries: this.$store.state.LanguageCode != 'zh-cn' && this.$store.state.LanguageCode != 'zh' && this.$store.state.LanguageCode != 'zh-tw' && this.$store.state.LanguageCode != 'zh-hk' ? require('~/static/json/areaCodeEn.json') : require('~/static/json/areaCodeCN.json'), // 中文国家列表
      searchData: [], // 搜索出来的数据
      scrollY: 0, // 获取实时滚动位置
      heightList: [] // 获取每一个li的高度
    }
  },
  computed: {
    currentIndex() {
      // 英文字母当前选中项
      const index = this.heightList.findIndex((item, index) => this.scrollY >= this.heightList[index] && this.scrollY < this.heightList[index + 1])
      return index > 0 ? index : 0
    }
  },
  watch: {
    // 监听是否展示该组件
    show(newV) {
      this.searchCountry = ''
      if (!this.firstLoad || !newV) return true
      this.firstLoad = false
      const delayTimer = setTimeout(() => {
        clearTimeout(delayTimer)
        this.getHeight()
      }, 0)
    },
    // 监听用户输入的搜索内容
    searchCountry(newV) {
      if (!newV) return false
      const [patt, coulist] = [new RegExp(newV, 'i'), []]
      this.countries?.forEach((item) => {
        item.data?.forEach((each) => {
          coulist.push(each)
        })
      })
      this.searchData = coulist != [] && coulist.filter((item) => patt.test(item.name) || item.code?.search(newV) != -1)
    }
  },
  created() {},
  mounted() {
    // this.$nextTick(() => {
    //   this.getHeight()
    // })
  },
  methods: {
    // 点击国家
    countryChange(i) {
      // 点击国家切换
      console.log(i)
      this.$store.commit('setuserCountry', i) // 更换点击的国家
      this.$emit('countryChange', i) // 关闭国家弹框
    },
    getHeight() {
      // 计算每一个英文首字母的列表高度
      const lis = this.$refs.rItem // 获取每一个li的高度
      let height = 0 // heightList的第一个元素为0
      this.heightList.push(height)
      lis.forEach((item) => {
        //  之后的高度即为当前li的高度加上之前面li的高度和
        height += item.clientHeight + 6
        this.heightList.push(height)
      })
    },
    // 国家滚动
    cyScroll() {
      this.scrollY = this.$refs.goodList.scrollTop || this.$refs.goodList.scrollTop
    },
    selectLeft(index) {
      // 字母点击滚动
      const rItem = this.$refs.rItem
      const el = rItem[index]
      this.seleLetter = el.getAttribute('data-num')
      const goodind = this.goodMenletter.findIndex((item, ind) => {
        return item == this.seleLetter ? ind : ''
      })
      this.$nextTick(() => {
        // console.log(this.heightList)
        this.$refs.goodList.scrollTop = this.heightList[goodind]
      })
    }
  }
}
